import { BonusApi } from '@sportheroes/oly-engine-api';

import { olyEngineApi } from './Config/olyEngineApi';

const { BONUS_API } = process.env;

export default new BonusApi(BONUS_API, {}, olyEngineApi);
